// LeftPanelNewContext.tsx
import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

interface LeftPanelNewContextType {
  refreshNewLeftPanel: boolean;
  toggleLeftPanelNewRefresh: () => void;
  setRefreshNewLeftPanel: (refreshLeftPanel: boolean) => void;
}

const LeftPanelNewContext = createContext<LeftPanelNewContextType | undefined>(
  undefined
);

interface LeftPanelNewProviderProps {
  children: ReactNode;
}

export const LeftPanelNewProvider: React.FC<LeftPanelNewProviderProps> = ({
  children,
}) => {
  const [refreshNewLeftPanel, setRefreshNewLeftPanel] =
    useState<boolean>(false);

  const toggleLeftPanelNewRefresh = () => {
    setRefreshNewLeftPanel((prev) => !prev);
  };

  return (
    <LeftPanelNewContext.Provider
      value={{
        refreshNewLeftPanel,
        toggleLeftPanelNewRefresh,
        setRefreshNewLeftPanel,
      }}
    >
      {children}
    </LeftPanelNewContext.Provider>
  );
};

export const useLeftPanelNewContext = (): LeftPanelNewContextType => {
  const context = useContext(LeftPanelNewContext);
  if (!context) {
    throw new Error(
      'useLeftPanelNewContext must be used within a LeftPanelNewProvider'
    );
  }
  return context;
};
